module.exports = __webpack_public_path__ + "static/media/louisiana.156a02aa.png";